import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=5831ccac&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=5831ccac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831ccac",
  null
  
)

export default component.exports